import PropTypes from 'prop-types';
import styles from './FJVoiceRecentlyList.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJAvatarAudioPlay from '../../../../common/components/audio/FJAvatarAudioPlay/FJAvatarAudioPlay.jsx';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';

const FJVoiceRecentlyList = props => {
    const { list, onUse } = props;

    return (
        <div>
            <div className={styles.title} style={{ marginTop: '24px' }}>
                {FJLocalStore._('recently-used')}
            </div>
            {list.map(item => {
                const { audioUrl, imgUrl, name, languageLabel } = FJTextToSpeechUtil.getVoiceItemShowInfo(
                    item,
                    item.fromType,
                );
                return (
                    <div className={styles.item} key={item.id || item.value}>
                        <div className={styles.item_left}>
                            <FJAvatarAudioPlay audioUrl={audioUrl} imgUrl={imgUrl} className={styles.avatar} />
                            <div className={styles.desc_box}>
                                <FJTextWithEllipsis className={styles.name} text={name} />
                                <FJTextWithEllipsis className={styles.country} text={languageLabel} />
                            </div>
                        </div>
                        <FJButton
                            text='use'
                            className={styles.use_btn}
                            type='gradient'
                            onClick={() => {
                                onUse(item, { fromType: item.fromType });
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

FJVoiceRecentlyList.propTypes = {
    list: PropTypes.array,
    onUse: PropTypes.func,
};
export default FJVoiceRecentlyList;
